module.exports = __webpack_public_path__ + "img/imgs2.a7f00398.png";